import {Component, OnInit} from '@angular/core';
import {ConstantsService} from "../ConstantsService";
import {AutorizacaoService} from "../../services/autorizacao.service";
import {RespostaChatbotInstagramService} from "../services/resposta-chatbot-instagram.service";
import {OpcaoRespostaChatbotInstagramService} from "../services/opcao-resposta-chatbot-instagram.service";

@Component({
  selector: 'app-tela-configuracao-chatbot-insta',
  templateUrl: './tela-configuracao-chatbot-insta.component.html',
  styleUrls: ['./tela-configuracao-chatbot-insta.component.scss']
})
export class TelaConfiguracaoChatbotInstaComponent implements OnInit {
  empresa: any;
  usuario: any;
  salvando: boolean = false;
  carregando: boolean = false;
  mensagemSucesso: any;
  mensagemCarregamento: string = '';
  respostaSelecionada: string = 'get_started';
  editandoMensagem: boolean = false;
  mensagemEditavel: string = '';
  editandoBotao: boolean = false;
  botaoSendoEditado: any = null;
  indiceBotaoEditado: number = -1;
  criandoNovoBotao: boolean = false;

  // Dados vindos do banco de dados
  respostasSalvas: any = {};
  opcoesSalvas: any = {};

  // Dados das respostas vindos do servidor
  respostasDisponiveis: any[] = [];

  // Mensagens dinâmicas - carregadas do banco de dados
  mensagensResposta: any = {};

  /* DADOS ORIGINAIS COMO BACKUP:
  mensagensResposta = {
    get_started: {
      mensagem: 'Olá! Bem-vindo a {{nomeEmpresa}} 😊\n\nA qualquer momento, você pode usar o menu abaixo para que eu possa te ajudar.\n\nO que você deseja?'
    },
    fazer_pedido: {
      mensagem: 'Clique no botão abaixo para fazer o seu pedido.'
    },
    cardapio: {
      mensagem: 'Segue nosso cardápio 🍽'
    },
    atendente: {
      mensagem: 'Olá, em breve um de nossos atendentes irá te responder.\n\nVocê gostaria de falar sobre o quê?'
    },
    horario_atendimento: {
      mensagem: 'Segunda a Sexta das 18:00 às 22:00.'
    },
    agradecimento: {
      mensagem: 'Por nada. Estou sempre por aqui. Só mandar um oi. :-)'
    },
    fallback: {
      mensagem: 'Desculpe-me, mas eu não entendo "{{message}}".'
    }
  };
  */

  // Opções para os formulários
  tiposBotao = [
    { valor: 'resposta_rapida', texto: 'Resposta Rápida' },
    { valor: 'link_externo', texto: 'Link externo' }
  ];

  destinosDisponiveis: any[] = [];

  // Editor de botão
  botaoEditor = {
    texto: '',
    tipo: 'resposta_rapida',
    destino: '',
    url: ''
  };

  // Estatísticas dinâmicas - calculadas baseadas nos dados reais
  estatisticas = {
    respostas: 0,
    botoes: 0,
    conexoes: 0,
    links: 0
  };

  // Botões dinâmicos - carregados do banco de dados
  botoesRespostas: any = {};

  /* DADOS ORIGINAIS COMO BACKUP:
  botoesRespostas: any = {
    get_started: [
      { texto: 'Ver Cardápio', tipo: 'resposta_rapida', destino: 'cardapio', icone: 'fas fa-eye' },
      { texto: 'Fazer Pedido', tipo: 'resposta_rapida', destino: 'fazer_pedido', icone: 'fas fa-shopping-cart' },
      { texto: 'Horários de Funcionamento', tipo: 'resposta_rapida', destino: 'horario_atendimento', icone: 'fas fa-clock' }
    ],
    fazer_pedido: [
      { texto: 'Acessar Cardápio', tipo: 'link_externo', url: 'https://exemplo.com/cardapio', icone: 'fas fa-external-link-alt' }
    ],
    cardapio: [
      { texto: 'Fazer Pedido', tipo: 'resposta_rapida', destino: 'fazer_pedido', icone: 'fas fa-shopping-cart' },
      { texto: 'Falar com Atendente', tipo: 'resposta_rapida', destino: 'atendente', icone: 'fas fa-headset' }
    ],
    atendente: [
      { texto: 'Voltar ao Menu', tipo: 'resposta_rapida', destino: 'get_started', icone: 'fas fa-home' }
    ],
    horario_atendimento: [
      { texto: 'Fazer Pedido', tipo: 'resposta_rapida', destino: 'fazer_pedido', icone: 'fas fa-shopping-cart' },
      { texto: 'Ver Cardápio', tipo: 'resposta_rapida', destino: 'cardapio', icone: 'fas fa-eye' }
    ],
    agradecimento: [
      { texto: 'Voltar ao Menu', tipo: 'resposta_rapida', destino: 'get_started', icone: 'fas fa-home' }
    ],
    fallback: [
      { texto: 'Voltar ao Menu', tipo: 'resposta_rapida', destino: 'get_started', icone: 'fas fa-home' },
      { texto: 'Falar com Atendente', tipo: 'resposta_rapida', destino: 'atendente', icone: 'fas fa-headset' }
    ]
  };
  */

  constructor(private constantsService: ConstantsService,
              private autorizacaoService: AutorizacaoService,
              private respostaChatbotInstagramService: RespostaChatbotInstagramService,
              private opcaoRespostaChatbotInstagramService: OpcaoRespostaChatbotInstagramService) {
  }

  ngOnInit() {
    this.usuario = this.autorizacaoService.getUser();

    this.constantsService.empresa$.subscribe( empresa => {
      if(empresa){
        this.empresa = empresa;
        this.carregarRespostas();
      }
    });
  }

  async carregarRespostas() {
    try {
      this.carregando = true;
      this.mensagemCarregamento = 'Carregando configurações do chatbot...';
      
      // Carregar respostas da empresa
      const respostas = await this.respostaChatbotInstagramService.listeRespostas();
      
      // Processar respostas carregadas para extrair tipos disponíveis e dados da empresa
      this.processarRespostasCarregadas(respostas);
      
      // Se não há configurações, criar padrões automaticamente
      if (respostas.length === 0) {
        await this.inicializarConfiguracoesPadrao();
        
        // Recarregar após inicialização
        const novasRespostas = await this.respostaChatbotInstagramService.listeRespostas();
        this.processarRespostasCarregadas(novasRespostas);
      }
      
      // Carregar opções/botões para cada resposta
      await this.carregarOpcoes();
      
      // Atualizar conexões após carregar todas as opções
      this.atualizarConexoes();
      
    } catch (error) {
      console.error('Erro ao carregar respostas:', error);
      this.mensagemCarregamento = '';
      alert('Erro ao carregar configurações. Tente recarregar a página.');
    } finally {
      this.carregando = false;
      this.mensagemCarregamento = '';
    }
  }


  processarRespostasCarregadas(respostas: any[]) {
    // Extrair respostas disponíveis únicas (tipos de resposta do sistema)
    const chaves: Set<string> = new Set();
    const respostasDisponiveis: any[] = [];
    
    respostas.forEach((resposta: any) => {
      if (!chaves.has(resposta.chaveResposta)) {
        chaves.add(resposta.chaveResposta);
        respostasDisponiveis.push({
          key: resposta.chaveResposta,
          titulo: resposta.titulo,
          icone: resposta.icone || 'fas fa-comment',
          conexoes: 0 // Será calculado depois baseado nas opções
        });
      }
    });
    
    // Atualizar arrays locais
    this.respostasDisponiveis = respostasDisponiveis;
    this.destinosDisponiveis = respostasDisponiveis.map(resposta => ({
      valor: resposta.key,
      texto: resposta.titulo
    }));
    
    // Organizar respostas por chave
    this.respostasSalvas = {};
    respostas.forEach((resposta: any) => {
      this.respostasSalvas[resposta.chaveResposta] = resposta;
      
      // Atualizar mensagens locais com dados do banco
      if (!this.mensagensResposta[resposta.chaveResposta]) {
        this.mensagensResposta[resposta.chaveResposta] = {};
      }
      this.mensagensResposta[resposta.chaveResposta].mensagem = resposta.mensagem;
    });

    // Atualizar estatísticas se não foram definidas na inicialização
    if (this.estatisticas.respostas === 0) {
      this.estatisticas.respostas = respostas.length;
    }
  }

  async carregarOpcoes() {
    try {
      // Organizar opções por chave de resposta
      this.opcoesSalvas = {};
      this.botoesRespostas = {}; // Limpar botões locais
      
      // Para cada resposta salva, carregar suas opções
      for (const chaveResposta in this.respostasSalvas) {
        const resposta = this.respostasSalvas[chaveResposta];
        
        // Carregar opções desta resposta específica
        const opcoes = await this.opcaoRespostaChatbotInstagramService.listeOpcoesPorResposta(resposta.id);
        
        if (opcoes && opcoes.length > 0) {
          this.opcoesSalvas[chaveResposta] = opcoes;
          this.botoesRespostas[chaveResposta] = [];
          
          opcoes.forEach((opcao: any) => {
            this.botoesRespostas[chaveResposta].push({
              id: opcao.id,
              texto: opcao.texto,
              tipo: opcao.tipo,
              destino: opcao.destino,
              url: opcao.url,
              icone: opcao.icone,
              ordem: opcao.ordem
            });
          });

          // Ordenar botões por ordem
          this.botoesRespostas[chaveResposta].sort((a: any, b: any) => (a.ordem || 0) - (b.ordem || 0));
        }
      }
      
    } catch (error) {
      console.error('Erro ao carregar opções:', error);
    }
  }

  atualizarConexoes() {
    // Atualizar conexões para cada resposta disponível baseado no número de opções
    this.respostasDisponiveis.forEach(resposta => {
      const opcoes = this.botoesRespostas[resposta.key] || [];
      resposta.conexoes = opcoes.length;
    });
  }

  async inicializarConfiguracoesPadrao() {
    try {
      this.mensagemCarregamento = 'Criando configurações padrão do chatbot...';
      
      const resultado = await this.respostaChatbotInstagramService.inicializarConfiguracoesPadrao();
      
      this.mensagemSucesso = `Configurações padrão criadas! ${resultado.totalRespostas} respostas e ${resultado.totalOpcoes} opções foram configuradas.`;
      
      // Atualizar estatísticas com dados reais
      this.estatisticas = {
        respostas: resultado.totalRespostas,
        botoes: resultado.totalOpcoes,
        conexoes: resultado.totalConexoes,
        links: resultado.totalLinks
      };
      
      return resultado;
      
    } catch (error) {
      console.error('Erro ao inicializar configurações padrão:', error);
      throw error;
    }
  }

  selecionarResposta(key: string) {
    this.respostaSelecionada = key;
    this.editandoMensagem = false;
    this.cancelarEdicaoBotao(); // Cancela edição de botão ao trocar de resposta
  }

  obterMensagemResposta(key: string): string {
    if (!this.mensagensResposta[key]) {
      return '';
    }

    let mensagem = this.mensagensResposta[key].mensagem;

    // Substitui placeholder da empresa
    if (this.empresa && mensagem.includes('{{nomeEmpresa}}')) {
      mensagem = mensagem.replace('{{nomeEmpresa}}', this.empresa.nome || 'Sua Empresa');
    }

    return mensagem;
  }

  iniciarEdicaoMensagem() {
    this.editandoMensagem = true;
    this.mensagemEditavel = this.obterMensagemResposta(this.respostaSelecionada);
  }

  async salvarMensagem() {
    try {
      this.salvando = true;
      this.fecheMensagemSucesso();
      
      const mensagem = this.mensagemEditavel;
      const chaveResposta = this.respostaSelecionada;
      
      if (!chaveResposta || !mensagem) {
        return;
      }

      const respostaExistente = this.respostasSalvas[chaveResposta];
      const respostaData = this.respostasDisponiveis.find(r => r.key === chaveResposta);
      
      if (respostaExistente) {
        // Atualizar resposta existente
        await this.respostaChatbotInstagramService.atualizeResposta(respostaExistente.id, {
          mensagem: mensagem
        });
        
        // Atualizar dados locais
        this.respostasSalvas[chaveResposta].mensagem = mensagem;
      } else {
        // Criar nova resposta
        const novaResposta = await this.respostaChatbotInstagramService.insiraResposta({
          chaveResposta: chaveResposta,
          titulo: respostaData?.titulo || chaveResposta,
          mensagem: mensagem,
          icone: respostaData?.icone || 'fas fa-comment',
          ativa: true,
          ordem: 0
        });
        
        // Salvar nos dados locais
        this.respostasSalvas[chaveResposta] = novaResposta;
      }
      
      // Atualizar mensagem local
      this.mensagensResposta[chaveResposta].mensagem = mensagem;
      
      this.editandoMensagem = false;
      
      // Mensagem de sucesso contextual
      const tituloResposta = this.obterTituloResposta(chaveResposta);
      if (respostaExistente) {
        this.mensagemSucesso = `💬 Mensagem "${tituloResposta}" atualizada com sucesso! Suas alterações já estão salvas no chatbot.`;
      } else {
        this.mensagemSucesso = `✨ Nova mensagem "${tituloResposta}" criada com sucesso! Agora você pode adicionar opções de resposta.`;
      }      
    } catch (error) {
      console.error('Erro ao salvar mensagem:', error);
      alert('Erro ao salvar mensagem. Tente novamente.');
    } finally {
      this.salvando = false;
    }
  }

  cancelarEdicaoMensagem() {
    this.editandoMensagem = false;
    this.mensagemEditavel = '';
  }

  obterBotoesResposta(key: string) {
    return this.botoesRespostas[key] || [];
  }

  obterTituloResposta(key: string): string {
    const resposta = this.respostasDisponiveis.find(r => r.key === key);
    return resposta ? resposta.titulo : 'Resposta';
  }

  iniciarEdicaoBotao(botao: any, indice: number) {
    this.editandoBotao = true;
    this.criandoNovoBotao = false;
    this.botaoSendoEditado = botao;
    this.indiceBotaoEditado = indice;
    this.botaoEditor = {
      texto: botao.texto || '',
      tipo: botao.tipo || 'resposta_rapida',
      destino: botao.destino || '',
      url: botao.url || ''
    };
  }

  verificarLimiteEAdicionarBotao() {
    const botoesExistentes = this.obterBotoesResposta(this.respostaSelecionada);
    
    if (botoesExistentes.length >= 3) {
      alert('Máximo de 3 opções permitido por resposta devido às limitações do Instagram.');
      return;
    }
    
    this.iniciarCriacaoNovoBotao();
  }

  iniciarCriacaoNovoBotao() {
    this.editandoBotao = true;
    this.criandoNovoBotao = true;
    this.botaoSendoEditado = null;
    this.indiceBotaoEditado = -1;
    this.botaoEditor = {
      texto: '',
      tipo: 'resposta_rapida',
      destino: this.destinosDisponiveis[0]?.valor || '',
      url: ''
    };
  }

  async salvarBotao() {
    try {
      this.salvando = true;
      
      const chaveResposta = this.respostaSelecionada;
      const resposta = this.respostasSalvas[chaveResposta];
      
      if (!resposta) {
        alert('É necessário salvar a mensagem antes de adicionar botões.');
        return;
      }

      if (this.criandoNovoBotao) {
        // Criando novo botão
        const novaOpcao = await this.opcaoRespostaChatbotInstagramService.insiraOpcao({
          respostaId: resposta.id,
          texto: this.botaoEditor.texto,
          tipo: this.botaoEditor.tipo,
          destino: this.botaoEditor.destino,
          url: this.botaoEditor.url,
          icone: this.obterIconePadrao(this.botaoEditor.tipo),
          ativo: true,
          ordem: this.obterBotoesResposta(chaveResposta).length
        });

        // Atualizar dados locais
        if (!this.botoesRespostas[chaveResposta]) {
          this.botoesRespostas[chaveResposta] = [];
        }
        if (!this.opcoesSalvas[chaveResposta]) {
          this.opcoesSalvas[chaveResposta] = [];
        }

        const novoBotao = {
          id: novaOpcao.id,
          texto: this.botaoEditor.texto,
          tipo: this.botaoEditor.tipo,
          destino: this.botaoEditor.destino,
          url: this.botaoEditor.url,
          icone: this.obterIconePadrao(this.botaoEditor.tipo)
        };

        this.botoesRespostas[chaveResposta].push(novoBotao);
        this.opcoesSalvas[chaveResposta].push(novaOpcao);
        
      } else if (this.botaoSendoEditado && this.indiceBotaoEditado >= 0) {
        // Editando botão existente
        const opcaoId = this.botaoSendoEditado.id;
        
        await this.opcaoRespostaChatbotInstagramService.atualizeOpcao(opcaoId, {
          texto: this.botaoEditor.texto,
          tipo: this.botaoEditor.tipo,
          destino: this.botaoEditor.destino,
          url: this.botaoEditor.url,
          icone: this.obterIconePadrao(this.botaoEditor.tipo)
        });

        // Atualizar dados locais
        const botoes = this.botoesRespostas[chaveResposta];
        if (botoes && botoes[this.indiceBotaoEditado]) {
          botoes[this.indiceBotaoEditado] = {
            ...botoes[this.indiceBotaoEditado],
            texto: this.botaoEditor.texto,
            tipo: this.botaoEditor.tipo,
            destino: this.botaoEditor.destino,
            url: this.botaoEditor.url,
            icone: this.obterIconePadrao(this.botaoEditor.tipo)
          };
        }

        // Atualizar opções salvas
        const opcaoSalva = this.opcoesSalvas[chaveResposta]?.find((o: any) => o.id === opcaoId);
        if (opcaoSalva) {
          opcaoSalva.texto = this.botaoEditor.texto;
          opcaoSalva.tipo = this.botaoEditor.tipo;
          opcaoSalva.destino = this.botaoEditor.destino;
          opcaoSalva.url = this.botaoEditor.url;
          opcaoSalva.icone = this.obterIconePadrao(this.botaoEditor.tipo);
        }
      }
      
      // Capturar dados para mensagem antes de cancelar edição
      const textoBotao = this.botaoEditor.texto;
      const ehNovoBotao = this.criandoNovoBotao;
      
      this.cancelarEdicaoBotao();
      
      // Atualizar conexões após salvar botão
      this.atualizarConexoes();
      
      // Mensagem de sucesso contextual para botões
      if (ehNovoBotao) {
        this.mensagemSucesso = `🔘 Novo botão "${textoBotao}" adicionado com sucesso! Os usuários já podem ver esta opção.`;
      } else {
        this.mensagemSucesso = `🔧 Botão "${textoBotao}" atualizado com sucesso! As alterações foram aplicadas.`;
      }
      
      setTimeout(() => {
        this.fecheMensagemSucesso();
      }, 4000);
      
    } catch (error) {
      console.error('Erro ao salvar botão:', error);
      alert('Erro ao salvar botão. Tente novamente.');
    } finally {
      this.salvando = false;
    }
  }

  async removerBotao() {
    try {
      this.salvando = true;
      
      if (this.botaoSendoEditado && this.indiceBotaoEditado >= 0) {
        const opcaoId = this.botaoSendoEditado.id;
        const chaveResposta = this.respostaSelecionada;
        
        if (opcaoId) {
          // Remover do banco
          await this.opcaoRespostaChatbotInstagramService.removaOpcao(opcaoId);
        }

        // Remover dos dados locais
        const botoes = this.botoesRespostas[chaveResposta];
        if (botoes) {
          botoes.splice(this.indiceBotaoEditado, 1);
        }

        const opcoesSalvas = this.opcoesSalvas[chaveResposta];
        if (opcoesSalvas) {
          const indiceOpcao = opcoesSalvas.findIndex((o: any) => o.id === opcaoId);
          if (indiceOpcao >= 0) {
            opcoesSalvas.splice(indiceOpcao, 1);
          }
        }
      }
      
      // Capturar texto do botão antes de cancelar edição
      const textoBotaoRemovido = this.botaoSendoEditado?.texto || 'botão';
      
      this.cancelarEdicaoBotao();
      
      // Atualizar conexões após remover botão
      this.atualizarConexoes();
      
      this.mensagemSucesso = `🗑️ Botão "${textoBotaoRemovido}" removido com sucesso! Esta opção não aparecerá mais para os usuários.`;
      
      setTimeout(() => {
        this.fecheMensagemSucesso();
      }, 4000);
      
    } catch (error) {
      console.error('Erro ao remover botão:', error);
      alert('Erro ao remover botão. Tente novamente.');
    } finally {
      this.salvando = false;
    }
  }

  cancelarEdicaoBotao() {
    this.editandoBotao = false;
    this.criandoNovoBotao = false;
    this.botaoSendoEditado = null;
    this.indiceBotaoEditado = -1;
    this.botaoEditor = {
      texto: '',
      tipo: 'resposta_rapida',
      destino: '',
      url: ''
    };
  }

  obterIconePadrao(tipo: string): string {
    switch (tipo) {
      case 'link_externo':
        return 'fas fa-external-link-alt';
      case 'resposta_rapida':
      default:
        return 'fas fa-reply';
    }
  }

  obterTextoDestino(destino: string): string {
    const destinoObj = this.destinosDisponiveis.find(d => d.valor === destino);
    return destinoObj ? destinoObj.texto : destino;
  }

  navegarParaResposta(destino: string) {
    // Verifica se o destino é uma resposta válida
    const respostaValida = this.respostasDisponiveis.find(r => r.key === destino);
    if (respostaValida) {
      this.selecionarResposta(destino);
    }
  }

  fecheMensagemSucesso() {
    delete this.mensagemSucesso;
  }
}
